import React from 'react'
import { REVIEW_STATUS_MESSAGES } from 'utils/constants/kypStatuses'

import styles from './styles'

function DisplayJustificative(props) {
  const { reviewer, reviewerComment, status, decisionNumber = null } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      {Number.isInteger(decisionNumber) ? <h3>{decisionNumber + 1}ª decisão</h3> : null}
      <p>
        <span>{`${
          REVIEW_STATUS_MESSAGES[status]
        } por: `}</span>
        {reviewer}
      </p>
      {reviewerComment && (
        <p>
          <span>{`Comentário do revisor: `}</span>
          {reviewerComment}
        </p>
      )}
    </div>
  )
}

export default DisplayJustificative
